export default "__VITE_ASSET__DUmjMeUm__"